import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';


const IncomeExpenseEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [ExpenseHeadOptions, setExpenseHeadOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedExpenseId, setselectedExpenseId] = useState(null);
    const [Remarks, setRemarks] = useState('');
    const [type, setType] = useState("");

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, branchId, token, logout]);


    useEffect(() => {
        // Fetch data when the component mounts or the `id` changes
        fetchData('IncomeExpenseApi', `/${id}`, token)
            .then((response) => {
                if (response?.responseCode === '1111') {
                    const data = response.response_data;

                    // Map response fields to formData state
                    setFormData((prevData) => ({
                        ...prevData,
                        ...data,
                        BillDate: formatDateForInput(data.BillDate), // Format BillDate for input type=date
                    }));

                    // Set Type for radio buttons
                    if (data.Type === "Expense") {
                        setType("1");
                    } else if (data.Type === "Income") {
                        setType("0");
                    }

                    // Set ExpenseHead for AsyncSelect
                    setSelectedOption({
                        value: data.AccountHeadId,
                        label: data.AccountHeadName || "", // Use ExpenseHeadName if available
                    });
                } else {
                    console.error('Unexpected response format:', response);
                }
            })
            .catch((error) => {
                console.error('Error fetching IncomeExpense Details:', error);
            });
    }, [id, token]);

    const fetchOptions = async () => {
        try {
            const response = await fetchData('ACcountHeadApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setExpenseHeadOptions(data);
                    return data.map(item => ({
                        value: item.id,
                        label: item.name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleInputChange = (newValue) => newValue;

    const handleExpenseHeadSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            ExpenseHeadId: selectedOption ? selectedOption.value : '', // Update formData
            UpdatedBy: userId,
        }));
    };

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BranchId: branchId,
        BillDate: "",
        Remarks: "",
        Amount: "",
        IsIncome: 0,
        BillNumber: "",
        UpdatedBy: userId,
        isSubmit: false,
        IsExpenseOrIncome: 'true', 
    });

    const handleChange = (event) => {
        const { name, value } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));

        if (name === "IsExpenseOrIncome") {
            const isReceipt = value === 'true';

            setFormData((prevData) => ({
                ...prevData,
                IsExpenseOrIncome: isReceipt,
            }));
        }

    };

    const submitData = async (e) => {
        setIsLoading(true);

        // Construct the updated form data object
        const updatedFormData = {
            ...formData,
            Id: id, // Ensure this is not null/undefined
            UpdatedBy: userId,
            IsExpenseOrIncome: formData.IsExpenseOrIncome === 'true' ? true : false,
        };


        try {
            // Use `updateData` to send the PUT/POST request
            const response = await updateData('IncomeExpenseApi', `${id}`, formData, token);

            console.log('Record updated successfully:', response.data);

            // Redirect to the desired page after a successful update
            history.push('/IncomeExpenseIndex');
        } catch (error) {
            // Handle errors, log them, and set an appropriate error message
            console.error('Receipt update error:', error);

            if (error.response?.data?.errors) {
                console.error('Validation Errors:', error.response.data.errors);
            }

            setErrorMessage('Failed to update receipt. Please try again.');
        } finally {
            // Ensure the loading state is reset
            setIsLoading(false);
        }
    };



    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);



    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    // FOR Current Date and Time 
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            BillDate: formattedDate,
            PaymentType: 1,
        }));
    }, []);


    return (
        <Fragment>

            <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '90%', overflow: 'auto' }}>
                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.5em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div >
                    <div className='w-full flex' style={{ marginTop: '10px' }}>

                        <h6 className="productHead flex-grow linkcolorBlack" style={{ fontFamily: 'Times new romans', fontWeight: 'bolder' }}>EDIT INCOME AND EXPENSE</h6>

                        <Button
                            // style={{ marginLeft: '8px', color: 'darkgreen' }}
                            style={{
                                background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                                color: 'black',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                //marginLeft: '5px',
                                marginLeft: '15px',

                            }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : <b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Save</b>}
                        </Button>

                        <Button
                            color="error"
                            component={Link}
                            to={{
                                pathname: "/IncomeExpenseIndex",
                                state: { from: "/IncomeExpenseCreate" },
                            }}
                            onClick={() => {
                                localStorage.setItem('shouldReload', 'true');
                            }}
                            className="linkcolor"
                            // style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                            style={{
                                background: 'linear-gradient(to right, #FFAAAA,#FFAAAA)',
                                color: 'black',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                //marginLeft: '5px',
                                marginLeft: '15px',

                            }}
                        >
                            <CloseIcon style={{ color: '#A91D3A', fontWeight: 'bolder' }} /><b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Cancel</b>
                        </Button>
                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-2 flex flex-wrap" style={{ marginTop: '20px' }}>
                        <div className="w-full sm:w-2/5 pr-2 mb-2 sm:mb-0">

                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="customer">
                                ExpenseHead
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.AccountHeadName}
                                type="text"
                                placeholder="Account Head"
                                name="AccountHeadName"
                                onChange={handleChange}
                                readOnly
                            />

                        </div>

                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Bill Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.BillDate ? formData.BillDate.split('T')[0] : ''}
                                type="date"
                                placeholder="Enter Reference Date"
                                name="BillDate"
                                onChange={handleChange}
                                readOnly
                            />

                        </div>

                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Bill Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.BillNo || ''}/${formData.FinYear || ''}`}
                                type="text"
                                placeholder="Enter BillNo"
                                name="BillNo"
                                readOnly
                            />

                        </div>
                    </div>

                    <div className="w-full mb-2 flex flex-wrap">

                        <div className="w-full sm:w-1/5 pl-2  sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="Amount">
                                Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Amount}
                                type="text"
                                placeholder="Enter Amount"
                                onChange={handleChange}
                                name='Amount'
                                max={formData.TotalBalAmt}
                                style={{ textAlign: 'right' }}
                            />
                        </div>
                        <div className="w-full sm:w-2/5 pl-2  sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="Remarks">
                                Remarks
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                name="Remarks"
                                placeholder="Enter Remarks"
                                value={formData.Remarks}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="flex items-center text-black" style={{ marginTop: '40px', marginLeft: '20px' }}>
                            <label className="flex items-center mr-6">
                                <input
                                    type="radio"
                                    name="IsExpenseOrIncome"
                                    value="true"
                                    checked={formData.IsExpenseOrIncome.toString() === 'true'}
                                    onChange={handleChange}
                                    className="mr-2"
                                />
                                Income
                            </label>
                            <label className="flex items-center">
                                <input
                                    type="radio"
                                    name="IsExpenseOrIncome"
                                    value="false"
                                    checked={formData.IsExpenseOrIncome.toString() === 'false'}
                                    onChange={handleChange}
                                    className="mr-2"
                                />
                                Expense
                            </label>
                        </div>



                        {/* <div className="flex items-center">
                            <input
                                type="radio"
                                id="expense"
                                name="type"
                                value="1"
                                checked={type === '1'}
                                onChange={(e) => setType(e.target.value)}
                                className="mr-2"
                            />
                            <label className="block tracking-wide text-gray-700 font-bold" style={{ color: 'darkblue' }}>Expense</label>
                            <input
                                type="radio"
                                id="income"
                                name="type"
                                value="0"
                                checked={type === '0'}
                                onChange={(e) => setType(e.target.value)}
                                className="mr-2"
                            />
                            <label className="block tracking-wide text-gray-700 font-bold ml-2" style={{ color: 'brown' }}>Income</label>
                        </div> */}

                    </div>
                </div>
            </div>

        </Fragment>
    );
}

export default IncomeExpenseEdit;
